import { ProductInfoResponse } from 'contracts/OrderItems';
import type { ProductData } from 'contracts/Products';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

interface GetProductsResponse {
  productOptions: string[];
  products: ProductData[];
}

interface CheckProductPayload {
  code: string;
  companyIds: Array<string | number>;
}

export function useProduct() {
  const { token } = useAuth();
  const getProducts = async (): Promise<GetProductsResponse> => {
    const { data: products } = await api.get<ProductData[]>(`/products`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Criar um Set para armazenar nomes de produtos únicos
    const uniqueProductNames = new Set<string>();

    products.forEach((product: ProductData) => {
      uniqueProductNames.add(product.name);
    });

    // Retornar apenas os nomes únicos
    return { productOptions: Array.from(uniqueProductNames), products };
  };

  const findProduct = async (code: string): Promise<ProductData> => {
    const { data: product } = await api.get<ProductData>(`/product/${code}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return product;
  };

  /**Verifica o uso do produto em outro agendamento */
  const checkProduct = async (payload: CheckProductPayload) => {
    const { data: dataCheck } = await api.post(`/order-item/check`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return dataCheck;
  };

  /**Busca as informações relacionadas à verificação ☝ */
  const getInfoCheckProduct = async (payload: CheckProductPayload) => {
    const { data: dataCheckInfo } = await api.post<ProductInfoResponse[]>(
      `/order-item/related-orders`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return dataCheckInfo;
  };

  return { getProducts, findProduct, checkProduct, getInfoCheckProduct };
}
